import { ComponentObservable, componentObserver } from '../../component-observer';
import {getSocialMediaPosts, socialMediaEndpoint} from '../../api/social-media-api';
import { createHtmlElementFromString } from '../../utils/html.utils';
/**
 * Module for social media posts gallery
 */
class SocialMediaModule implements ComponentObservable {
    /**
     * Selector of all social-media components that must be initialized in javascript.
     */
    componentSelector = '.social-media';

    /**
     * Card for social media post
     */

    postCard = `
        <div class="social-media-post">
            <div class="social-media-post-header">
                <div class="user-pic">
                    <img src="https://images.sociablekit.com/sources/facebook-page-posts/HamiltonMedical/profile.jpg">
                </div>
                <div class="post-info">
                    <span class="page-name font-bold"></span>
                    <span class="post-date"></span>
                </div>
            </div>
            <div class="social-media-post-content">
                
            </div>
            <div class="social-media-post-media">
                
            </div>
            <div class="social-media-post-footer">
                <div class="likes-count">
                    <svg width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.31005 0.606794C8.46052 0.268236 8.79626 0.0500488 9.16675 0.0500488C10.0784 0.0500488 10.9528 0.412213 11.5974 1.05687C12.2421 1.70153 12.6042 2.57587 12.6042 3.48755V5.88338H16.3787C16.7542 5.87998 17.126 5.95782 17.4686 6.11159C17.813 6.26616 18.1197 6.49377 18.3674 6.77864C18.6151 7.06351 18.7979 7.39884 18.9032 7.76137C19.0084 8.12391 19.0336 8.505 18.977 8.87823L17.827 16.3781C17.8269 16.3784 17.827 16.3779 17.827 16.3781C17.7327 16.9988 17.4172 17.5653 16.9388 17.9719C16.4618 18.3774 15.8546 18.5974 15.2287 18.5917H3.33341C2.64275 18.5917 1.98037 18.3173 1.49199 17.829C1.00361 17.3406 0.729248 16.6782 0.729248 15.9875V10.1542C0.729248 9.46355 1.00361 8.80117 1.49199 8.31279C1.98037 7.82442 2.64275 7.55005 3.33341 7.55005H5.22416L8.31005 0.606794ZM4.89591 9.42505H3.33341C3.14003 9.42505 2.95456 9.50187 2.81782 9.63862C2.68107 9.77536 2.60425 9.96083 2.60425 10.1542V15.9875C2.60425 16.1809 2.68107 16.3664 2.81782 16.5031C2.95456 16.6399 3.14003 16.7167 3.33341 16.7167H4.89591V9.42505ZM6.77091 16.7167H15.244C15.4199 16.7187 15.5905 16.6571 15.7245 16.5432C15.8585 16.4293 15.9468 16.2709 15.9732 16.097L17.1232 8.59686C17.1232 8.59673 17.1232 8.597 17.1232 8.59686C17.139 8.49249 17.132 8.38552 17.1025 8.28414C17.0731 8.18263 17.0219 8.08874 16.9525 8.00898C16.8832 7.92922 16.7973 7.86549 16.7009 7.8222C16.6044 7.77892 16.4997 7.75712 16.394 7.75832L16.3834 7.75844L11.6667 7.75838C11.149 7.75838 10.7292 7.33865 10.7292 6.82088V3.48755C10.7292 3.07315 10.5646 2.67572 10.2716 2.38269C10.116 2.22705 9.93086 2.10764 9.72941 2.02987L6.77091 8.6865V16.7167Z" fill="#9CA2AB"></path>
                    </svg>
                    <span class="likes-count-value"></span>
                </div>
                <div class="comment-count">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_20_4403)">
                            <path d="M20 13.6539V17.8206C20 18.4836 19.7366 19.1195 19.2678 19.5884C18.7989 20.0572 18.163 20.3206 17.5 20.3206H13.3333C12.1642 20.3194 11.016 20.0108 10.0039 19.4257C8.99172 18.8407 8.15121 17.9997 7.56667 16.9873C8.19489 16.9828 8.82098 16.9135 9.435 16.7806C9.90262 17.3653 10.4958 17.8373 11.1707 18.1616C11.8455 18.4858 12.5846 18.6541 13.3333 18.6539H17.5C17.721 18.6539 17.933 18.5661 18.0893 18.4098C18.2455 18.2536 18.3333 18.0416 18.3333 17.8206V13.6539C18.3331 12.905 18.1643 12.1656 17.8395 11.4908C17.5146 10.8159 17.042 10.2229 16.4567 9.75559C16.5907 9.14168 16.6611 8.51559 16.6667 7.88725C17.6791 8.4718 18.5201 9.31231 19.1051 10.3245C19.6902 11.3366 19.9988 12.4848 20 13.6539ZM14.9808 8.36309C15.0588 7.28945 14.9047 6.21162 14.529 5.20283C14.1534 4.19405 13.565 3.27794 12.8038 2.51677C12.0426 1.7556 11.1265 1.1672 10.1178 0.79155C9.10896 0.415904 8.03113 0.261815 6.9575 0.339753C5.05493 0.55703 3.29744 1.4624 2.01598 2.88537C0.734522 4.30834 0.0175226 6.15073 0 8.06559L0 12.2656C0 14.3756 1.25583 15.3206 2.5 15.3206H7.25C9.16567 15.3041 11.0092 14.5876 12.4332 13.306C13.8571 12.0245 14.7633 10.2664 14.9808 8.36309V8.36309ZM11.625 3.69642C12.2166 4.28934 12.674 5.00242 12.9661 5.78741C13.2582 6.5724 13.3784 7.41098 13.3183 8.24642C13.1405 9.73282 12.4254 11.1029 11.3078 12.0989C10.1901 13.0948 8.74699 13.6479 7.25 13.6539H2.5C1.72667 13.6539 1.66667 12.5914 1.66667 12.2656V8.06559C1.67361 6.56923 2.22721 5.12701 3.22326 4.01032C4.21932 2.89363 5.58916 2.17948 7.075 2.00225C7.21333 1.99225 7.35167 1.98725 7.49 1.98725C8.25772 1.98654 9.01807 2.13712 9.72757 2.43038C10.4371 2.72365 11.0818 3.15386 11.625 3.69642Z" fill="#9CA2AB"></path>
                        </g>
                        <defs>
                            <clipPath id="clip0_20_4403">
                                <rect width="20" height="20" fill="white" transform="translate(0 0.320801)"></rect>
                            </clipPath>
                        </defs>
                    </svg>
                    <span class="comment-count-value"></span>
                </div>
                <div class="share-count">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="height: 20px; color: rgb(156, 162, 171);">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.375 12.5C6.10089 12.5 7.5 11.1009 7.5 9.375C7.5 7.64911 6.10089 6.25 4.375 6.25C2.64911 6.25 1.25 7.64911 1.25 9.375C1.25 11.1009 2.64911 12.5 4.375 12.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.625 8.125C17.3509 8.125 18.75 6.72589 18.75 5C18.75 3.27411 17.3509 1.875 15.625 1.875C13.8991 1.875 12.5 3.27411 12.5 5C12.5 6.72589 13.8991 8.125 15.625 8.125Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.625 18.125C17.3509 18.125 18.75 16.7259 18.75 15C18.75 13.2741 17.3509 11.875 15.625 11.875C13.8991 11.875 12.5 13.2741 12.5 15C12.5 16.7259 13.8991 18.125 15.625 18.125Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M7.28809 8.24253L12.7114 6.13336" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M7.1709 10.7733L12.8292 13.6025" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    <span class="share-count-value"></span>
                </div>
            </div>
        </div>
    `;
    /**
     * Initialize all social-media components on the current page.
     * @param observe Boolean if the socialMedia module should listen for changes in the DOM and initialize dynamically
     *   added social media components
     */
    initializeAll(observe: boolean): Promise<void> {
        return new Promise((resolve) => {
            const allSocialMediaComponents = document.querySelectorAll(this.componentSelector);
            for (let i = 0; i < allSocialMediaComponents.length; i++) {
                this.initialize(allSocialMediaComponents[i] as HTMLElement);
            }

            if (observe) {
                this.startListening();
            }
            resolve();
        });
    }

    /**
     * Listen for changes in DOM and initialize social-media components when new ones appear
     */
    startListening(): void {
        componentObserver.subscribeListener(this);
    }

    /**
     * Initialize the given social-media element.
     * @param pageTitle The social-media root element that should be initialized
     */
    initialize(socialMedia: HTMLElement): void {
        componentObserver.markElementAsInitialized(this.componentSelector, socialMedia);
        getSocialMediaPosts().then(posts => {
            posts.forEach(postData => {
                const postCard = createHtmlElementFromString(this.postCard);
                const descriptionElem = postCard.querySelector('.social-media-post-content');
                const mediaContainer = postCard.querySelector('.social-media-post-media');
                const likeCountContainer = postCard.querySelector('.likes-count-value');
                const sharesCountContainer = postCard.querySelector('.share-count-value');
                const commentCountContainer = postCard.querySelector('.comment-count-value');
                let attachments: any = {};
                if (postData.attachments !== '') {
                    attachments = JSON.parse(postData.attachments);
                }

                const fromData = JSON.parse(postData.from);
                if (attachments.data) {
                    const postInfo = attachments.data[0];
                    if (postInfo.description) {
                        descriptionElem.textContent = postInfo.description;
                    }

                    if (postInfo.subattachments && postInfo.subattachments.data?.length > 0) {
                        for (const subattachment of postInfo.subattachments.data) {
                            const img = document.createElement('img');
                            const url = new URL(subattachment.media.image.src);
                            const params = new URLSearchParams(url.search);
                            const ncOhc = params.get("_nc_ohc").replace(/^\d+/, "");
                            img.src = subattachment.media.image.src;
                            img.style.maxWidth = '5rem';
                            img.setAttribute('data-overlay-id', ncOhc);
                            mediaContainer.appendChild(img);
                            socialMedia.appendChild(createHtmlElementFromString(`
                                <div id="${ncOhc}" class="overlay-wrapper">
                                    <div class="overlay overlay--article-images">
                                        <div class="overelay__content">
                                            <button class="button button--overlay">
                                                <svg width="20" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.625 20.375L20.375 1.625" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    <path d="M20.375 20.375L1.625 1.625" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                </svg>
                                            </button>
                                            <figure>
                                                <img src="${subattachment.media.image.src}">
                                            </figure>
                                        </div>
                                    </div>     
                                </div>`));
                        }
                    }
                }
                const dateElem = postCard.querySelector('.post-date');
                const nameElem = postCard.querySelector('.page-name');
                const imageElem: HTMLImageElement = postCard.querySelector('.post-image');
                const dateObject = new Date(postData.date);

                postCard.setAttribute('href', postData.permalinkUrl);

                dateElem.textContent = dateObject.toLocaleDateString("en-US", {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });

                nameElem.textContent = fromData.name;
                if (postData.picture) {
                    imageElem.src = postData.picture;
                }

                likeCountContainer.textContent = '0';
                sharesCountContainer.textContent = '0';
                commentCountContainer.textContent = '0';
                if (postData.likes) {
                    likeCountContainer.textContent = postData.likes.toString();
                }
                if (postData.comments) {
                    commentCountContainer.textContent = postData.comments.toString();
                }
                if (postData.shares) {
                    sharesCountContainer.textContent = postData.shares.toString();
                }

                socialMedia.appendChild(postCard);
            });
        });
    }
}

const socialMediaModule = new SocialMediaModule();
export { socialMediaModule as socialMedia };